import React from 'react';
import style from './disconnected.module.scss'
import { ClipLoader } from '@missionlabs/smartagent-chat-components-lib';

interface Props {}

const Disconnected: React.FC<Props> = (props) => {

    return (
        <div className={style.disconnectedContainer}>
            <div className={style.loader}>
                <p>Disconnected...</p>
                <ClipLoader />
            </div>
        </div>
    )
}

export default Disconnected;